import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { retireServiceWorker } from './core/retireServiceWorker';
import './styles/app.scss';

retireServiceWorker();

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
